<mat-card class="demo-inline-calendar-card">
    <mat-calendar></mat-calendar>
</mat-card>